import { Component, OnInit } from '@angular/core';
import { DocumentService } from 'src/app/_services/document/document.service';
import { Document } from 'src/app/Model/doucment';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {
  document : Document[]=[];
  constructor(private serviceDocument : DocumentService) { }

  ngOnInit(): void {
    this.afficheDocument();
  }
  afficheDocument()
  {
    this.serviceDocument.AfficherDocument().subscribe(res=>{
      this.document = res;
      //console.log(this.document);
    });

  }
}
